import { buildApiActionTypes } from './apiActionTypes';

export const acceptTermsOfServiceActionTypes = buildApiActionTypes(
  'ACCEPT_TERMS_OF_SERVICE'
);
